import Image from 'next/image';

import { type FlexProps, Flex } from '@chakra-ui/react';

import { CLAUDE_ENGINEER_ASSETS } from '~/features/claude-engineer-2026/constants';

const GRADIENT_BORDER_SX = {
  background:
    'linear-gradient(rgba(10, 11, 15, 0.8), rgba(10, 11, 15, 0.8)) padding-box, linear-gradient(90deg, rgba(195, 80, 0, 0.4) 0%, rgba(195, 80, 0, 0.224) 100%) border-box',
  border: '1px solid transparent',
} as const;

type ClaudeEngineerNoLogoTagProps = FlexProps & {
  size?: 'experience' | 'hero';
};

export function ClaudeEngineerNoLogoTag({ size = 'hero', ...flexProps }: ClaudeEngineerNoLogoTagProps) {
  const isHero = size === 'hero';

  return (
    <Flex
      alignItems='center'
      alignSelf='flex-start'
      backdropFilter='blur(20px)'
      borderRadius='4px'
      color='orange.300'
      flexShrink={0}
      fontFamily='condensed'
      fontSize={isHero ? '16px' : '0.9375rem'}
      fontWeight='500'
      gap={2}
      letterSpacing={isHero ? '1.28px' : '0.9px'}
      lineHeight='1'
      padding='8px 16px 8px 10px'
      sx={GRADIENT_BORDER_SX}
      textTransform='uppercase'
      whiteSpace='nowrap'
      {...flexProps}
    >
      <Image alt='' height={16} src={CLAUDE_ENGINEER_ASSETS.starIcon} width={16} />
      New Nanodegree Program
    </Flex>
  );
}
